/* eslint-disable max-len */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

// Define styles using makeStyles
const useStyles = makeStyles({
  contained: {
    color: '#1367B2',
    background: '#fff',
    border: '2px solid #1367B2',
    textTransform: 'capitalize',
    borderRadius: '8px',
    lineHeight: '32px',
    padding: '0px 16px',
    minHeight: '38px',
    fontSize: '16px',
    '&:hover': {
      border: '2px solid #1367B2',
      color: '#fff',
      background: '#1367B2',
    },
    '&.Mui-disabled': {
      color: '#A0A0A0', // Gray color for disabled text
      border: '2px solid rgba(245,245,245,1)!important', // Gray border
      background: 'rgba(245,245,245,1)',
      cursor: 'default',
    },
    '@media (min-width: 768px)': { // Apply desktop padding for screens 768px and above
      padding: '0px 20px',
    },
  },

  outlined: {
    color: '#1367B2',
    background: '#fff',
    border: '2px solid #1367B2',
    textTransform: 'capitalize',
    borderRadius: '8px',
    lineHeight: '32px',
    padding: '0px 16px',
    minHeight: '38px',
    fontSize: '16px',
    '&:hover': {
      border: '2px solid #1367B2',
      color: '#fff',
      background: '#1367B2',
    },
    '&.Mui-disabled': {
      color: '#A0A0A0',
      border: '2px solid rgba(245, 245, 245, 1) !important', // Fixed !important spacing
      background: 'rgba(245, 245, 245, 1)',
      cursor: 'default',
    },
    '@media (min-width: 768px)': { // Apply desktop padding for screens 768px and above
      padding: '0px 20px',
    },
  },

  orangecontained: {
    color: '#fff',
    background: '#EC5834',
    border: '2px solid #EC5834',
    textTransform: 'capitalize',
    borderRadius: '8px',
    lineHeight: '32px',
    padding: '0px 16px',
    minHeight: '38px',
    fontSize: '16px',
    '&:hover': {
      border: '2px solid #EC5834',
      color: '#EC5834',
      background: '#fff',
    },
    '&.Mui-disabled': {
      color: '#A0A0A0', // Gray color for disabled text
      border: '2px solid rgba(245,245,245,1)!important', // Gray border
      background: 'rgba(245,245,245,1)',
      cursor: 'default',
    },
    '@media (min-width: 768px)': { // Apply desktop padding for screens 768px and above
      padding: '0px 20px',
    },
  },

  greencontained: {
    color: '#fff',
    background: '#3F960A',
    textTransform: 'capitalize',
    borderRadius: '8px',
    lineHeight: '32px',
    padding: '6px 16px',
    minHeight: '38px',
    fontSize: '16px',
    '&:hover': {
      color: '#fff',
      background: '#3F960A',
      boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    },
    '&.Mui-disabled': {
      color: '#A0A0A0', // Gray color for disabled text
      background: 'rgba(245,245,245,1)',
      cursor: 'default',
    },
    '@media (min-width: 768px)': { // Apply desktop padding for screens 768px and above
      padding: '6px 16px',
    },
  },

  greenoutlined: {
    color: '#fff',
    background: '#3F960A',
    textTransform: 'capitalize',
    borderRadius: '8px',
    lineHeight: '32px',
    padding: '6px 16px',
    minHeight: '38px',
    fontSize: '16px',
    '&:hover': {
      color: '#fff',
      background: '#3F960A',
      boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    },
    '&.Mui-disabled': {
      color: '#A0A0A0', // Gray color for disabled text
      background: 'rgba(245,245,245,1)',
      cursor: 'default',
    },
    '@media (min-width: 768px)': { // Apply desktop padding for screens 768px and above
      padding: '6px 16px',
    },
  },

});

// contained: {
//   color: '#fff',
//   background: '#1367B2',
//   border: '1px solid #1367B2',
//   textTransform: 'capitalize',
//   borderRadius: '10px',
//   lineHeight: '32px',
//   padding: '0px 24px',
//   minHeight: '32px',
//   fontSize: '1rem',
//   '&:hover': {
//     border: '1px solid #1367B2',
//     color: '#1367B2',
//     background: 'none',
//   },
// },

// Contained Button Component
export function MauContainedBtn({
  children, onClick, disabled, height, width, fontSize, borderRadius, endIcon, style = {},custom,className
}) {
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`${classes.contained} ${(custom && className)?className:""}`}
      endIcon={endIcon}
      style={{
        minHeight: height, width, fontSize, borderRadius, ...style,
      }}
    >
      {children}
    </Button>
  );
}

export function MauOrangeContainedBtn({
  children, onClick, disabled, height, width, fontSize, borderRadius, endIcon,
}) {
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={classes.orangecontained}
      endIcon={endIcon}
      style={{
        minHeight: height, width, fontSize, borderRadius,
      }}
    >
      {children}
    </Button>
  );
}

export function MauGreenContainedBtn({
  children, onClick, disabled, height, width, fontSize, borderRadius, endIcon,
}) {
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={classes.greencontained}
      endIcon={endIcon}
      style={{
        minHeight: height, width, fontSize, borderRadius,
      }}
    >
      {children}
    </Button>
  );
}

export function MauGreenOutlinedBtn({
  children, onClick, disabled, height, width, fontSize, borderRadius, endIcon,
}) {
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={classes.greenoutlined}
      endIcon={endIcon}
      style={{
        minHeight: height, width, fontSize, borderRadius,
      }}
    >
      {children}
    </Button>
  );
}

// Outlined Button Component
export function MauOutlinedBtn({
  children, onClick, disabled, height, width, fontSize, borderRadius, endIcon,minWidth
}) {
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      endIcon={endIcon}
      className={classes.outlined}
      style={{
        minHeight: height, width, fontSize, borderRadius,minWidth
      }}
    >
      {children}
    </Button>
  );
}
